const SUPPORTED_CLIENTS = ['claude', 'chatgpt', 'claude_code'];

const RETURN_URLS = {
  claude: 'https://claude.ai/directory/connectors/measure-studio',
};

export const normalizeMcpClient = (client) => {
  if (typeof client !== 'string' || !SUPPORTED_CLIENTS.includes(client)) return 'generic';

  return client;
};

export const mcpClientReturnUrl = client => RETURN_URLS[normalizeMcpClient(client)] || null;
